import { Component, OnInit, TemplateRef, ViewChild, inject } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { Router, RouterModule } from '@angular/router';
import { ApiservicesService } from '../../Services/Apis/apiservices.service';
import { QuestionControlService } from '../../inputfileds/form_services/question-control.service';
import { DepartmentService } from '../../inputfileds/form_services/department/department.service';
import { Inputfiledsbase } from '../../inputfileds/models/inputfiledsbase';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { SettingServiceService } from '../../Services/setting-service.service';
import { Observable } from 'rxjs/internal/Observable';
import { DynamicFormQuestionComponent } from '../../inputfileds/dynamic-form-question/dynamic-form-question.component';
import { MatIconModule } from '@angular/material/icon';
import { ToastService } from '../../Services/toast/toast.service';
import { ToastComponent } from '../../components/toast/toast.component';
import { PaginationComponent } from '../../components/pagination/pagination.component';
import { PermissionService } from '../../components/Authentication/services/permission.service';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateDirective } from '../../components/Utilites/Directives/translate.directive';
export interface departmentView {
  index: number,
  id: number,
  organization_id: number,
  department_manager_id: number,
  department_code: string,
  department_name: string,
  description: string,
}

@Component({
  selector: 'app-department-view',
  imports: [
    DynamicFormQuestionComponent,
    MatTableModule,
    MatIconModule,
    MatCheckboxModule,
    CommonModule,
    MatButtonModule,
    RouterModule,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatMenuModule,
    FormsModule,
    ToastComponent,
    PaginationComponent,
    MatDialogModule,
    TranslateDirective
  ],
  templateUrl: './department.component.html',
  styleUrl: './department.component.scss',
  providers: [ApiservicesService, QuestionControlService, DepartmentService]
})

export class DepartmentComponent implements OnInit {
  questions: Inputfiledsbase<string>[] | null = [];
  questions$: Observable<Inputfiledsbase<any>[]> | null;
  hodquestions: Inputfiledsbase<string>[] | null = [];
  hodquestions$: Observable<Inputfiledsbase<any>[]> | null | undefined;
  form!: FormGroup;
  editform!: FormGroup;
  payLoad = '';
  departmentData = []
  displayedColumns: string[] = ['department_code', 'department_name', 'hod_name', 'description', 'action'];
  dataSource = new MatTableDataSource<departmentView>();
  selection = new SelectionModel<departmentView>(true, []);
  // private apisevice = inject(ApiservicesService)
  lookupdatas: any;
  showaddflag: boolean = false;
  datesend: any;
  total_count: any;
  paginationData: any;
  actiondata: any;
  errorMessage = '';
  @ViewChild('modalTemplate') modalTemplate!: TemplateRef<any>;
  selecteditData: any;
  dialogRef!: MatDialogRef<any>;

  constructor(
    private apiservice: ApiservicesService,
    private qcs: QuestionControlService,
    private service: DepartmentService,
    private toast: ToastService,
    private router: Router,
    private dialog: MatDialog,
    private permissionService: PermissionService,
  ) {
    this.actiondata = this.permissionService.getactiondata();
    if (this.actiondata?.view === false || this.actiondata?.edit === false) {
      this.displayedColumns.splice(this.displayedColumns.indexOf('actions'), 1);
    }
    this.questions$ = service.getdepartmentform();
    this.questions$.subscribe(q => this.questions = q);
  }

  getDepartmentList(){
    this.apiservice.getdepartmentdetails(this.paginationData).subscribe((res) => {
      this.departmentData = res.rows
      this.total_count = res.total_count;
      this.dataSource = new MatTableDataSource<departmentView>(res.rows)
    })
  }

  showadd() {
    this.showaddflag = !this.showaddflag;
  }

  ngOnInit(): void {
    this.getDepartmentList();
    this.form = this.qcs.toFormGroup(this.questions as Inputfiledsbase<string>[]);
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }
    this.selection.select(...this.dataSource.data);
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: departmentView): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.index + 1}`;
  }

  pagination(event: any) {
    this.paginationData = event;
    this.getDepartmentList();
  }

  onSubmit() {
    this.payLoad = this.form.getRawValue();
    this.datesend = this.form.value;
    this.datesend.department_manager_id = parseInt(this.form.value.department_manager_id);
    this.datesend.organization_id = parseInt(this.form.value.organization_id);
    this.createAPi(this.datesend);
  }

  createAPi(event: any) {
    this.apiservice.createdepartment(event).subscribe((res: any) => {
      if (res.code === 201 && res.status === true) {
        if (this.total_count == 0) {
          this.apiservice.onboarding_status_updation({ "module_name": "COLLEGE_MANAGEMENT_SYSTEM", "sub_module_name": "DEPARTMENTS" }).subscribe();
        }
        this.toast.showToast('success', 'Saved Successfuly');
        this.form.reset();
        this.showadd();
        this.getDepartmentList();
      } else {
        this.errorMessage = res.message;
        this.toast.showToast('danger', `Error: ${res.message}`);
      }
    },
      (error) => {
        this.toast.showToast('warning', error.message);
      }
    );
  }

  openedithodDialog(event: any): void {
    this.selecteditData = event;
    this.hodquestions$ = this.service.getdepartmenthodform();

    this.hodquestions$.subscribe(q => {
      this.hodquestions = q;

      // Step 1: Create the form
      this.editform = this.qcs.toFormGroup(this.hodquestions as Inputfiledsbase<string>[]);

      // Step 2: Patch value
      this.editform.setValue({
        department_manager_id: event.department_manager_id
      });
      // Step 3: Open modal
      this.dialogRef = this.dialog.open(this.modalTemplate, {
        width: '400px',
      });
    });


    this.dialogRef.afterClosed().subscribe(result => {
      this.editform.reset();
    });
  }

  closeHodDialog(): void {
    this.dialogRef.close('Closed from inside');
  }

  oneditSubmit() {
    this.payLoad = this.editform.getRawValue();
    this.editAPi(this.editform.value);
  }

  editAPi(event: any) {
    this.apiservice.editdepartment(event, parseInt(this.selecteditData.id)).subscribe((res: any) => {
      if ((res.code === 204 || res.code === '204') && res.status === true) {
        // if (this.total_count == 0) {
        //   this.apiservice.onboarding_status_updation({ "module_name": "COLLEGE_MANAGEMENT_SYSTEM", "sub_module_name": "DEPARTMENTS" }).subscribe();
        // }
        this.toast.showToast('success', 'Saved Successfuly');
        this.editform.reset();
        this.getDepartmentList();
        this.closeHodDialog();
      } else {
        this.errorMessage = res.message;
        this.toast.showToast('danger', `Error: ${res.message}`);
      }
    },
      (error) => {
        this.toast.showToast('warning', error.message);
      }
    );
  }
}